import { Grid } from "@mui/material";
import FormSelect from "./FormSelect";
import FormTextField from "./FormTextField";
import { CALL_TYPE_OPTIONS, URGENCY_OPTIONS } from "./ticketFormConfig";

// Call type, urgency and the free-text description of the problem
const TicketDetailsFields = ({ formData, handleChange }) => (
  <>
    <Grid item xs={12} md={6}>
      <FormSelect
        id="callType"
        label="סוג קריאה"
        value={formData.callType}
        onChange={handleChange("callType")}
        options={CALL_TYPE_OPTIONS}
      />
    </Grid>
    <Grid item xs={12} md={6}>
      <FormSelect
        id="urgency"
        label="דחיפות"
        value={formData.urgency}
        onChange={handleChange("urgency")}
        options={URGENCY_OPTIONS}
      />
    </Grid>
    <Grid item xs={12}>
      <FormTextField
        multiline
        rows={4}
        label="תיאור תקלה"
        value={formData.text}
        onChange={handleChange("text")}
        placeholder="תיאור הבעיה..."
      />
    </Grid>
  </>
);

export default TicketDetailsFields;
